// extracted by mini-css-extract-plugin
module.exports = {"page":"myPaginator_page__2FdlN"};